import {
  createFileRoute,
  redirect,
} from '@tanstack/react-router';

export const Route = createFileRoute('/_app/_authenticated/settings/')({
  // component: RouteComponent,
  loader: async () => {
    redirect({
      to: '/settings/profile',
      throw: true,
    });
  },
});
